<template>
  <div>
    <div>
      <statisticsTop></statisticsTop>
    </div>
    <div class="char-box-cla">
      <apiBarChar></apiBarChar>
      <apiLineChart></apiLineChart>
    </div>
  </div>
</template>

<script>
import statisticsTop from './apiStatistics/statisticsTop'
import apiBarChar from './apiStatistics/apiBarChar.vue'
import apiLineChart from './apiStatistics/apiLineChart'
export default {
  data() {
    return {}
  },
  components: {
    statisticsTop,
    apiBarChar,
    apiLineChart
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped lang="less">
.char-box-cla {
  margin-top: 12px;
  display: flex;
  flex-wrap: nowrap;
}
@media screen and (max-width: 980px) {
  .char-box-cla {
    flex-wrap: wrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/statistics/apiStatistics.vue